module.exports = __webpack_public_path__ + "img/conto_ok.e2d549e2.png";